import { createContext, useReducer } from 'react';
import { cardsReducer } from './cardsReducer';

export const CardContext = createContext();
export const CARD_FORM_INITIAL_VALUES = {
    type: 'virtual',
    cardholderId: null,
    label: '',
    limitAmount: 0,
    memo: '',
    billingAddress: {
        line1: '123 Main St',
        line2: '',
        city: 'New York',
        state: 'NY',
        country: 'US',
        postalCode: '10001'
    },
    autoLock: null,
    has_manual_replenish: 1
};

export const REQUEST_CARD_FORM_INITIAL_VALUES = {
    type: 'virtual',
    cardholderId: null,
    label: '',
    limitAmount: 0,
    memo: '',
    autoLock: null,
    has_manual_replenish: 1
};

const cardSectionState = {
    cancelLoader: false,
    card: CARD_FORM_INITIAL_VALUES,
    request: REQUEST_CARD_FORM_INITIAL_VALUES,
    cardId: null,
    cards: [],
    creditAvailable: 0,
    currentCard: false,
    deleteFrame: false,
    errorMessage: '',
    idCardToDisplay: null,
    isCardFormModalOpen: false,
    isRequestCardModalOpen: false,
    isReviewCardModalOpen: false,
    isRequestEditLimitModalOpen: false,
    cardRequestToReview: CARD_FORM_INITIAL_VALUES,
    cardToRequestEditLimit: {},
    isConfirmAddressModalOpen: false,
    isConfirmExitDialogOpen: false,
    isEditCardFormModal: false,
    isEditCardFormModalOpen: false,
    isEditCardFundsModalOpen: false,
    isFormSubmitting: false,
    isPasswordModalOpen: false,
    isShippingModalOpen: false,
    isUnallocatadBalanceModalOpen: false,
    isUserFormModalOpen: false,
    mccCodes: [],
    previousCard: CARD_FORM_INITIAL_VALUES,
    providerToken: {},
    shouldUpdateCardholders: false,
    shouldUpdateCardList: true,
    statistics: {
        accountBalance: 0,
        activeCards: 0,
        zeroBalanceCards: 0,
        allocated: 0,
        businessSpent: 0,
        creditAvailable: 0,
        creditLimit: 0,
        totalAmountSpentInCurrentMonth: 0,
        availableToAddtoCards: 0
    },
    total: 0
};

export const CardProvider = ({ children }) => {
    const [state, dispatch] = useReducer(cardsReducer, cardSectionState);

    return <CardContext.Provider value={{ ...state, dispatch }}>{children}</CardContext.Provider>;
};
